import { render, staticRenderFns } from "./AxFilesystemNodeMove.vue?vue&type=template&id=b62463fc&scoped=true&"
import script from "./AxFilesystemNodeMove.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNodeMove.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNodeMove.vue?vue&type=style&index=0&id=b62463fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62463fc",
  null
  
)

export default component.exports